import React from "react";
import { Props } from "./types";

function UnavailabilityIcon({ className }: Props) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="15.868"
      height="15.868"
      viewBox="0 0 15.868 15.868"
    >
      <path
        data-name="Icon material-beach-access"
        d="M13.431,14.692l1.261-1.261,5.679,5.68L19.112,20.37Zm3.785-5.052,2.522-2.521A8.923,8.923,0,0,0,7.128,7.1,9.848,9.848,0,0,1,17.216,9.641ZM7.1,7.128A8.92,8.92,0,0,0,7.12,19.735l2.522-2.521A9.845,9.845,0,0,1,7.1,7.128ZM7.12,7.11l-.009.009c-.335,2.654,1.032,6.066,3.792,8.834L15.955,10.9C13.2,8.142,9.774,6.775,7.12,7.11Z"
        transform="translate(-4.502 -4.502)"
        fill="#232F34"
      />
    </svg>
  );
}

export { UnavailabilityIcon };
